import React, { useState } from "react";
import { connect } from "react-redux";
import { Image } from 'react-bootstrap';
import { Anchor } from "antd";
import TitleError from '../../assets/images/campaignStreamline/title_error.png';

const { Link } = Anchor;

const AnchorSubTitle = ({
  item,
  errorSectionList,
}) => (
  <div className='anchor-title-error-container'>
    {
      errorSectionList.includes(item.anchorKey) && (
        <Image
          src={TitleError}
          className="anchor-title-error"
        />
      )
    }
    <Link className='anchor-sub-title' href={`#${item.anchorKey}`} title={item.title} />
  </div>
)


const BaseAnchor = ({
  anchorTitle ="NAVIGATION",
  anchorTitleTips,
  defaultShowTitleTips = false,
  displayRefreshBtn = false,
  onClickRefreshBtn = () => {},
  anchorListConfig = [],
  errorSectionList,
}) => {
  const [showTips, setShowTips] = useState(anchorTitleTips && defaultShowTitleTips);
  
  return (
    <div className='anchor-page-container'>
      <div className='anchor-page-navigation-container'>
        <label
          className="create-section-title anchor-page-title"
          onClick={() => setShowTips(!showTips)}
        >
          {anchorTitle}
          {/* <CustomTips
            popoverClassName="tips-popover"
            detail={
              <div className='anchor-tips'>
                <Image
                  src={CloseButton}
                  className="tips-close"
                  onClick={() => {
                    setShowTips(false);
                  }}
                />
                <span>
                  On Approve/Publish, missing required fields are marked
                  with a warning icon. Click “Fill Now” to complete.
                  When you have completed filling in the fields, you can click 'Refresh' to update
                </span>
                <span
                  className='anchor-page-do-not-display-again'
                  onClick={() => {
                    setShowTips(false);
                    dispatch({
                      type: 'settings/updateAdminTipConfig',
                      payload: {
                        data: {
                          hideCampaignNavigationTip: true,
                        }
                      }
                    })
                  }}
                >
                  Do not display again
                </span>
              </div>
            }
            placement="top"
            show={showTips}
          /> */}
        </label>
        {displayRefreshBtn && 
          <span
            className='anchor-refresh-error'
            onClick={onClickRefreshBtn}
          >
            Refresh
          </span>
        }
      </div>

      <Anchor
        offsetTop={90}
        onClick={(e, link) => e.preventDefault()}
      >
        {anchorListConfig?.map(({
          title,
          anchorKey,
          className,
          sublist
        }) => (
          <Link className={`anchor-title ${className || ""}`} href={`#${anchorKey || ""}`} title={title} >
            {
              sublist.map(item => (
                <AnchorSubTitle item={item} errorSectionList={errorSectionList} />
              ))
            }
          </Link>
        ))}
      </Anchor>
    </div>
  );
}

const mapPropsToState = (state) => ({
});

export default  connect(mapPropsToState)(BaseAnchor);